import React from 'react';
import { motion } from 'framer-motion';
type ButtonVariant = 'primary' | 'secondary';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: ButtonVariant;
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
}
const variantClasses: Record<ButtonVariant, string> = {
  primary: 'text-white bg-gold hover:bg-gold-deep shadow-[0_10px_24px_-10px_rgba(194,155,44,0.7)]',
  secondary: 'text-white bg-navy-deep hover:bg-navy border border-gold/60 shadow-[0_10px_24px_-12px_rgba(14,37,67,0.6)]'
};
const baseClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full transition-colors duration-300 text-center';
export function Button({
  children,
  className = '',
  variant = 'primary',
  href,
  target,
  rel,
  onLinkClick,
  ...props
}: ButtonProps) {
  const classes = `${baseClasses} ${variantClasses[variant]} ${className}`;
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={classes} whileHover={{
      scale: 1.04
    }} whileTap={{
      scale: 0.96
    }} data-id="element-59" data-mp="d174imjh6b9t">
        {children}
      </motion.a>;
  }
  return <motion.button className={classes} whileHover={{
    scale: 1.04
  }} whileTap={{
    scale: 0.96
  }} {...props} data-id="element-60" data-mp="88w2ne56cfem">
      {children}
    </motion.button>;
}